import { render, staticRenderFns } from "./addShipmentCompanyForm.vue?vue&type=template&id=0076bb66"
import script from "./addShipmentCompanyForm.vue?vue&type=script&lang=js"
export * from "./addShipmentCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports